export enum LegalPageType {
  Charter = 'charter-terms',
  Cookies = 'cookies-policy',
  Credit = 'credit-policy',
  DataSubjects = 'data-subjects-access-rights',
  Privacy = 'privacy-policy',
  Terms = 'terms-of-use'
}
